import { OutgoingPostbackLogTable } from "components/Tables/OutgoingPostbackLogTable/OutgoingPostbackLogTable";
import { TenantPage } from "components/UI/TenantPage/TenantPage";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute";
import { getLogHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute(
    "/_authenticated/$tenantSlug/_layout/log/_layout/tracking/_layout/tracking-api/"
)({
    component: OutgoingPostbackLogPage,
    staticData: {
        permissions: [PermissionEnum.OutgoingPostbackLogView],
        showInSideMenu: false,
        label: "pages.log.tracking.to.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.log.tracking.to.title"),
        };
    },
});

function OutgoingPostbackLogPage() {
    return (
        <TenantPage headerNavigationItems={getLogHeaderItems}>
            <OutgoingPostbackLogTable />
        </TenantPage>
    );
}
